import { ProjectCheckErrorType } from "@biz/projectCalculation/ProjectDefinitions";

import type { ArticleAvailability } from "@biz/definitions/ArticleDefinitions";

// const orange = "#fa6a18";
const orange = "#F39200";
const pageBackground = "#F0F0F0";

function colors<T extends Record<string, string>>(colors: T): T {
  return colors;
}

export const AppColors = {
  iconColor: orange,
  orange,
  main: colors({
    dashboard: orange,
    projects: "#5BACCC",
    offer: "#D78875",
    order: "#94BB4B",
  }),
  sideBar: colors({
    backgroundLight: "#f8f8f8",
    background: "#f0f0f0",
    // background: "#f0f0f0",
    backgroundDark: "#e8e8e8",
    backgroundDarker: "#e0e0e0",
    backgroundOld: "#5a6970",
    textLight: "#5a6970",
    text: "#364045",
    textDark: "#1f272b",
  }),
  tabs: colors({
    background: "#788489",
    tabColor: pageBackground,
    tabColorHover: "#DCDFE1"
  }),
  page: colors({
    background: pageBackground,
    topBarBackground: pageBackground,
    bottomBarBackground: pageBackground,
    iconsBackground: "#5a6970",
    menuButtonBackground: "#394348",
    text: "#5A686F",
  }),
  project: colors({
    rowBackground: "#DCDFE1",
    detailBackground: "#788489",
    rowMenuColor: "#A4ACB0",
    text: "#5A686F",
    textDark: "#364045",
    headerLines: "#5A686F"
  }),
  assets: colors({
    assetBackground: "#D2D6D8",
    text: "#5A686F",
    textMid: "#808080",
    textLight: "#A4ACB0",
  }),
  topBar: colors({
    background: "#ecedf1",
    backgroundHover: "#cccccc",
    controls: "#5a6970",
    menuBackground: "#364045",
    color: "#5D686E",
    colorHover: "#364045",
  }),
  sideBarOld: colors({
    background: "#5A686F", // "#f0f0f0"
    backgroundDark: "#485359", // "#dddddd",
    backgroundDarkest: "#364045",
    text: pageBackground,
    textLightGrey: "#D1D1D1",
    textDark: "#5A686F"
  }),
  bottomBar: colors({
    text: "#5A686F",
  }),
  shop: colors({
    articleBackground: "#DCDFE1",
    sumBackground: "#CED2D4",
    imageBackground: "#f6f6f6",
    text: "#5A686F",
    darkText: "#3B464D",
    green: "#6A964A",
    blue: "#6A4A96",
    action: "#CED2D4",
  }),
  dialog: colors({
    background: "#D5DEE3",
    text: "#5A686F",
    controls: "#5A686F",
    darkText: "#3B464D"
  }),
  table: colors({
    headerText: "#5A686F",
    innerSeperators: pageBackground,
    rowMenuColor: "#A4ACB0",
    grey: "#808E95",
  }),
  form: colors({
    overlayBackground: "#D1D9DC",
    background: pageBackground,
    backgroundDark: "#dddddd",
    backgroundLight: "#f8f8f8",
    text: "#5A6970",
    darkText: "#3B464D",
    lightText: "#bbbbbb",
    textBackground: "#ffffff",
    errorText: orange,
    errorTextFatal: "#ff0000",
    controlBackground: "#ffffff",
    whiteText: "#ffffff",
    disabledText: "#7e898e",
  }),
  svg: colors({
    background: pageBackground,
    gridColorMain: "#5A6970",
    gridColorSub: "#5A6970",
    measureTextColor: "#222222",
    measureTextShadowColor: "#ffffff",
    axleColorText: "#5A6970",
    distOutColorText: "#5A6970",
    distInColorText: "#1029b5",
    validAreaColor: "#00FF0040",
    validAreaColor2: "#00800040",
    ropeColor: "#333333",
    strokeColor: "#444444",
    axleColor: orange,
    infoLineColor: orange,
  }),
  quick: {
    ...(colors({
      textColor: "#555555",
      lightGrey: "#AAAAAA",
      green: "#71A825",  // new quick green design // "#52ae32",
      orange: "#f29200",
      red: "#d30a10",
      blue: "#5BACCC",

      border: "#71A825",
      // border: "#f29200", // "#71A825",
      headerBackground: "#d1d9dc",
      lightGreyBackground: "#f0f4f5",
      sectionBackground: "#5A6970"
    })),
    outerPadding: "20px",
    innerPadding: "40px",
  },
  ...(colors({
    black: "#000000",
    white: "#ffffff",
    red: "#ff0000",
    yellow: "#FEDC31",
    purple: "#81007F",
    green: "#89bd32",
    darkGreen: "#42711f",
    lightGrey: "#a1abb1",
    id: "#747c81",
    idDark: "#6c7377",
    hoverLines: "#3B464D",
    hoverModel: "#e7feff",
    selectModel: "#FEAD00",
  })),
  getColorsForError: (type: ProjectCheckErrorType): string | undefined => {
    switch (type) {
      case ProjectCheckErrorType.Hint:
        return AppColors.yellow;
      case ProjectCheckErrorType.Warning:
        return AppColors.orange; // "#ff4141";
      case ProjectCheckErrorType.Error:
        return "#ff0000"; // "#ff4141";
      case ProjectCheckErrorType.FatalError:
        return "#81007F";
    }
    return "#ff00ff"
  },
  calcColorForAvailability: (availability: ArticleAvailability | undefined): string => {
    switch (availability) {
      case "available": return AppColors.quick.green;
      case "longerDelivery": return AppColors.quick.orange;
      case "onRequest": return AppColors.quick.blue;
      case "unavailable": return AppColors.quick.red;
    }
    return AppColors.quick.green
  }
};